// extracted by mini-css-extract-plugin
module.exports = {"root":"SoftwareBlade-module--root--1dSWJ","textColumn":"SoftwareBlade-module--textColumn--1B7De"};